'use client'

import Image from 'next/image';
import ErrorPageBox from "@/src/mui-custom/error-page/error-page-box/error-page-box";
import {Box, Stack} from "@mui/material";
import {PAPER_BACKGROUND} from "@/src/constant/constant";
import ButtonToStart from "@/src/components/common/button-to-start/button-to-start";
import PrimaryButton from "@/src/mui-custom/button/button-primary";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHome, faRefresh} from "@fortawesome/pro-duotone-svg-icons";
import SuccessButton from "@/src/mui-custom/button/button-success";
import {useEffect} from "react";

export default function Error({error}: { error: Error & { digest?: string } }) {
    useEffect(() => {
        if (
            process.env.NEXT_PUBLIC_REPORT_ERROR === 'true'
            && !error.message.includes('Loading chunk')
            && !error.message.includes('Connection closed.')
            && !error.message.includes('network error')
        ) {
            const data = {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    message: error.message,
                    digest: error.digest || null,
                    stack: error.stack || null,
                    cause: error.cause || null,
                    location: window?.location?.href,
                }),
            };

            fetch("/api/errors/report/telegram", data);
            fetch("/api/errors/report/redmine", data);
        }
    }, [error]);

    return (
        <>
            <Box
                sx={{
                    backgroundImage: `url(${PAPER_BACKGROUND})`,
                    backgroundColor: 'background.default',
                    height: '100vh',
                }}
            >
                <Box
                    component="main"
                    sx={{
                        maxWidth: '1400px',
                        m: 'auto',
                        paddingTop: {xs: '5vh', sm: '5vh', md: '5vh', lg: '15vh', xl: '15vh'},
                    }}
                >
                    <ErrorPageBox>
                        <Box
                            sx={{
                                maxWidth: 500,
                                maxHeight: 500,
                                width: '100%',
                                margin: '0 auto',
                                textAlign: 'center',
                                '& img': {
                                    maxWidth: '500px',
                                    maxHeight: '500px',
                                    width: '100%',
                                },
                            }}
                        >
                            <Image src="/images/error.svg" width={500} height={500} alt="Error"/>
                        </Box>
                        <Box sx={{textAlign: 'center', mt: 3}}>
                            <Stack direction="row" spacing={2} justifyContent="center">
                                <PrimaryButton
                                    href={'/'}
                                    sx={{
                                        borderRadius: ".75rem",
                                        fontWeight: 700,
                                        fontSize: "1.1rem",
                                        display: "flex",
                                        alignItems: "left",
                                        gap: 0.3,
                                    }}
                                >
                                    <FontAwesomeIcon icon={faHome}/>
                                    Return Home
                                </PrimaryButton>
                                <SuccessButton
                                    sx={{
                                        borderRadius: ".75rem",
                                        fontWeight: 700,
                                        fontSize: "1.1rem",
                                        display: "flex",
                                        alignItems: "left",
                                        gap: 0.3,
                                    }}
                                    onClick={() => window.location.reload()}
                                >
                                    <FontAwesomeIcon icon={faRefresh}/>
                                    {"Try Again"}
                                </SuccessButton>
                            </Stack>
                        </Box>
                    </ErrorPageBox>
                </Box>
            </Box>
            <ButtonToStart/>
        </>
    );
}
